import Episode from '../models/Episode';

function renderEpisodeLength(episode: Episode) {
  let h = Math.floor(episode.audio_length_sec / 3600);
  let m = Math.floor(episode.audio_length_sec / 60);
  let s = episode.audio_length_sec % 60;
  if (h > 0) m %= 60;
  if (h == 0 && m ==0 && s ==0) return '- -';
  let hour = h > 0 ? h.toString() + ':' : '';
  let min = m > 9 ? m.toString() + ':' : '0' + m.toString() + ':';
  let sec = s > 9 ? s.toString() : '0' + s.toString();
  return hour + min + sec;
}

export default renderEpisodeLength;
